import * as React from 'react';
import Styles from './ConfirmationMessage.module.scss';

export interface OwnProps {
  title: string;
  description?: string;
  image: string;
  actionTitle?: string;
  onAction?: () => void;
}

export const ConfirmationMessageWithAction: React.FC<OwnProps> = ({
  title,
  image,
  description,
  actionTitle,
  onAction,
}) => {
  return (
    <div className={Styles.confirmationMessageContainer}>
      <div className={Styles.imageContainer}>
        <img className={Styles.image} src={image} alt="" />
      </div>
      <div className={Styles.textColumn}>
        <div className={Styles.title}>{title}</div>
        <div className={Styles.description}>{description}</div>
        {actionTitle && onAction && (
          <button className={Styles.actionButton} onClick={onAction}>
            {actionTitle}
          </button>
        )}
      </div>
    </div>
  );
};
